import { useAccount } from '../../contexts/account/AccountContexts';

const useBillingType = () => {
  const { accountResponse } = useAccount();

  if (
    !accountResponse ||
    (!accountResponse.addons.includes('TEST_BILLING') && !accountResponse.addons.includes('BILLING'))
  ) {
    return null;
  }

  if (accountResponse.addons.includes('BILLING')) {
    return true;
  }

  if (accountResponse.addons.includes('TEST_BILLING')) {
    return false;
  }
};

export default useBillingType;
